<template>
  <main>
    <!--
    <h1>unencrypted</h1>
    <div><pre>{{unencrypted}}</pre></div>
    <h1>encrypted</h1>
    <div><pre>{{encrypted}}</pre></div>
    -->
    <!-- <section-header>Questions for my review</section-header> -->
    <div class="">
      <div class="">
        <div class="">
          <div id="myreviews">
            <section class="action__dashboard" id="mymedslist" v-if="display.includes('myreviews')">
              <h1 class="qrs-header-xl">
                Questions for my review
              </h1>
              <div class="">
                <!--<button class="button__default action-btn--danger mb--xs" @click="testsend">TEST</button>-->
                <div
                  v-if="(!myreview.currentreview || myreview.currentreview.length < 1) && (!myreview.previousreviews || myreview.previousreviews.length < 1)"
                  class="info__panel">
                  <img class="mt--small mb--small" :src=images.myreview />
                  <p>
                    Questions for you to answer before and after your medicines
                    review. Share your answers with the GP or pharmacist to inform
                    discussion and follow-up to your review.
                  </p>


                </div>
                <div class="info__panel">
                  <button class="button__default button--primary" @click="startcreateoutcomesset_clicked">
                    Answer new set of review questions
                  </button>
                </div>
                <div class="action__panel-primary borderless"
                  v-if="myreview.currentreview && myreview.currentreview.length > 0">
                  <h2>My current review questions</h2>
                  <div v-if="myreview.currentreview && myreview.currentreview.length > 0">
                    <p>Review date : <span v-html="getDateOnlyAsString2(myreview.currentreview[0].reviewdate)"></span></p>
                    <button class="button__default action-btn--danger mb--xs"
                      @click="deletecurrentreview_clicked">Delete</button>
                    <!-- <p v-html="displaydate(q.datecreated,q.datecreated)"></p> -->
                    <div class="action__panel pt--0">
                      <div class="action__panel__item full-width"
                        @click="viewoutcomesset(myreview.currentreview[0], 'prereview')">
                        <h4>Pre review</h4>
                        <label>Last updated :</label>
                        <span
                          v-html="displaydate(myreview.currentreview[0].lastupdated_prereview, myreview.currentreview[0].datecreated)"></span><br />
                        <div class="action__panel__item-status">
                          {{ displaystatus(myreview.currentreview[0].prereviewstatus) }}</div>
                        <icon icon="chevron-right" />
                      </div>

                      <div class="action__panel__item action__panel__item--border-b full-width"
                        @click="viewoutcomesset(myreview.currentreview[0], 'postreview')">
                        <h4>Post review</h4>
                        <label>Last updated :</label>
                        <span
                          v-html="displaydate(myreview.currentreview[0].lastupdated_postreview, myreview.currentreview[0].datecreated)"></span><br />
                        <div class="action__panel__item-status">
                          {{ displaystatus(myreview.currentreview[0].postreviewstatus) }}</div>
                        <icon icon="chevron-right" />
                      </div>
                    </div>
                  </div>
                </div>


                <div class="action__panel-secondary full-width"
                  v-if="myreview.previousreviews && myreview.previousreviews.length > 0 && myreview.previousreviews[0]">
                  <h2>My previous review responses</h2>
                  <button class="button__default action-btn--danger mb--xs"
                    @click="deletetoppastreview_clicked">Delete</button>

                  <div>
                    <p>Review date : <span v-html="getDateOnlyAsString2(mostrecent_review.reviewdate)"></span></p>
                    <!-- <p v-html="displaydate(q.datecreated,q.datecreated)"></p> -->
                    <div class="action__panel pt--0">
                      <div class="action__panel__item full-width" v-if="mostrecent_review.prereview_shared"
                        @click="viewoutcomesset(mostrecent_review, 'prereview')">
                        <h4>Pre review</h4>
                        <label>Last updated :</label>
                        <span
                          v-html="displaydate(mostrecent_review.lastupdated_prereview, mostrecent_review.datecreated)"></span><br />
                        <div class="action__panel__item-status">{{ displaystatus(mostrecent_review.prereviewstatus) }}</div>
                        <icon icon="chevron-right" />
                      </div>

                      <div class="action__panel__item full-width" v-if="mostrecent_review.postreview_shared"
                        @click="viewoutcomesset(mostrecent_review, 'postreview')">
                        <h4>Post review</h4>
                        <label>Last updated :</label>
                        <span
                          v-html="displaydate(mostrecent_review.lastupdated_postreview, mostrecent_review.datecreated)"></span><br />
                        <div class="action__panel__item-status">{{ displaystatus(mostrecent_review.postreviewstatus) }}
                        </div>
                        <icon icon="chevron-right" />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="action__panel"
                  v-if="myreview.previousreviews && myreview.previousreviews.length > 0 && myreview.previousreviews[0]">
                  <div @click="displaysummaryclicked">
                    <h2>Past Responses</h2>
                    <p>View past results from your<br /> previous medicine reviews</p>
                    <icon icon="chevron-right" />
                  </div>
                </div>

              </div>

              <!-- <div v-if="(!myreview.currentreview || myreview.currentreview.length < 1) && (!myreview.previousreviews || myreview.previousreviews.length < 1)" class="row">
                <div class="button-container">
                  <button
                    class="button__default button--primary"
                    @click="startcreateoutcomesset_clicked"
                  >
                    Answer new set of review questions
                  </button>
                  <button
                    class="button__default button--secondary"
                    @click="clear"
                  >
                    clear (FOR TEST ONLY, WILL BE REMOVED)
                  </button>
                </div>
              </div> -->

              <div class="action__panel-info">

                <h5>PDF Download</h5>
                <p>If you can’t complete these forms using the app then please download the questionnaires below to fill
                  in the answers offline.</p>
                <div class="action__panel pt--0">
                  <!-- <a href="https://managemeds.scot.nhs.uk/myreview/prereview.pdf" title="Download the pre review documents to complete offline"> -->
                  <a href="https://rightdecisions.scot.nhs.uk/SinglePageApps/QuestionsForMyReview/prereview.pdf"
                    title="Download the pre review documents to complete offline">
                    <div class="action__panel__item full-width">
                      <h4>Pre review</h4>
                      <icon icon="download" />
                    </div>
                  </a>
                  <!-- <a href="https://managemeds.scot.nhs.uk/myreview/postreview.pdf" title="Download the post review documents to complete offline"> -->
                  <a href="https://rightdecisions.scot.nhs.uk/SinglePageApps/QuestionsForMyReview/postreview.pdf"
                    title="Download the post review documents to complete offline">
                    <div class="action__panel__item full-width">
                      <h4>Post review</h4>
                      <icon icon="download" />
                    </div>
                  </a>
                </div>
              </div>
            </section>

            <modal v-bind:class="newreviewdate_modal_css" title="Answer questions for my review">
              <div slot="body">
                <p>Please enter date of medicines review</p>
                <ul class="error">
                  <li v-if="newreviewdate_error.length > 0">
                    {{ newreviewdate_error }}
                  </li>
                </ul>
                <vuejs-datepicker v-model="newreviewdate" name="newreviewdate" format="dd/MM/yyyy"
                  placeholder="dd/MM/yyyy" input-class="form-control dp"
                  @change="validatenewreviewdate"></vuejs-datepicker>
              </div>
              <div slot="footer">
                <ul class="modal__footer__container">
                  <li>
                    <a @click="createreviewcancelclicked" role="button"
                      class="modal__button modal__button--cancel">Cancel</a>
                  </li>
                  <li>
                    <a @click="createreviewconfirmedclicked" class="modal__button modal__button--add"
                      role="button">Continue</a>
                  </li>
                </ul>
              </div>
            </modal>
            <modal v-bind:class="warning_hasnotstarted_modal_css" title="Answer questions for my review">
              <div slot="body">
                <p>You need to finalise at least one of the current reviews before you can create a new review, or
                  optionally delete the current review</p>
              </div>
              <div slot="footer">
                <ul class="modal__footer__container">
                  <li>
                    <a @click="createreviewcancelclicked" role="button" class="modal__button modal__button--cancel">Ok</a>
                  </li>
                </ul>
              </div>
            </modal>
            <modal v-bind:class="warning_hasonefinalised_modal_css" title="Answer questions for my review">
              <div slot="body">
                <p>You have not answered all your current pre- and post-review questions. Are you sure you want to start
                  questions for a new review? You will not be able to edit the current questions if you proceed</p>
              </div>
              <div slot="footer">
                <ul class="modal__footer__container">
                  <li>
                    <a @click="createreviewcancelclicked" role="button"
                      class="modal__button modal__button--cancel">Cancel</a>
                  </li>
                  <li>
                    <a @click="continuehasfinalisedconfirmedclicked" class="modal__button modal__button--add"
                      role="button">Continue</a>
                  </li>
                </ul>
              </div>
            </modal>
            <modal v-bind:class="warning_deletereview_modal_css" title="Warning">
              <div slot="body">
                <p>Are you sure you want to delete this review?</p>
              </div>
              <div slot="footer">
                <ul class="modal__footer__container">
                  <li>
                    <a @click="deletereviewcancelclicked" role="button"
                      class="modal__button modal__button--cancel">Cancel</a>
                  </li>
                  <li v-if="deletewarning_showcontinue">
                    <a @click="deletereviewconfirmedclicked" class="modal__button modal__button--add"
                      role="button">Continue</a>
                  </li>
                </ul>
              </div>
            </modal>
            <modal v-bind:class="warning_deletemostrecentreview_modal_css" title="Warning">
              <div slot="body">
                <p>Are you sure you want to delete the most recent review?</p>
              </div>
              <div slot="footer">
                <ul class="modal__footer__container">
                  <li>
                    <a @click="deletemostrecentreview_cancelclicked" role="button"
                      class="modal__button modal__button--cancel">Cancel</a>
                  </li>
                  <li>
                    <a @click="deletemostrecentreview_confirmclicked" class="modal__button modal__button--add"
                      role="button">Continue</a>
                  </li>
                </ul>
              </div>
            </modal>
            <modal v-bind:class="warning_deletepastreview_modal_css" title="Warning">
              <div slot="body">
                <p>Are you sure you want to delete all past review(s)?</p>
              </div>
              <div slot="footer">
                <ul class="modal__footer__container">
                  <li>
                    <a @click="deletepastreview_cancelclicked" role="button"
                      class="modal__button modal__button--cancel">Cancel</a>
                  </li>
                  <li>
                    <a @click="deletepastreview_confirmclicked" class="modal__button modal__button--add"
                      role="button">Continue</a>
                  </li>
                </ul>
              </div>
            </modal>
            <modal v-bind:class="warning_deletetoppastreview_modal_css" title="Warning">
              <div slot="body">
                <p>Are you sure you want to delete all past review(s)?</p>
              </div>
              <div slot="footer">
                <ul class="modal__footer__container">
                  <li>
                    <a @click="deletetoppastreview_cancelclicked" role="button"
                      class="modal__button modal__button--cancel">Cancel</a>
                  </li>
                  <li>
                    <a @click="deletetoppastreview_confirmclicked" class="modal__button modal__button--add"
                      role="button">Continue</a>
                  </li>
                </ul>
              </div>
            </modal>
            <modal v-bind:class="confirm_deleted_message_modal_css" title="Warning">
              <div slot="body">
                <p>Your responses have been deleted?</p>
              </div>
              <div slot="footer">
                <ul class="modal__footer__container">
                  <li>
                    <a @click="confirm_deleted_message_okclicked" role="button"
                      class="modal__button modal__button--cancel">OK</a>
                  </li>
                </ul>
              </div>
            </modal>
            <modal v-bind:class="confirm_emailsent_modal_css" title=" ">
              <div slot="body">
                <div v-html="emailsent_message"></div>
              </div>
              <div slot="footer">
                <ul class="modal__footer__container">
                  <li>
                    <a @click="confirm_emailsent_modal_okclicked" role="button"
                      class="modal__button modal__button--cancel">OK</a>
                  </li>
                </ul>
              </div>
            </modal>
            <!-- Summary -->
            <div id="summary" v-if="display.includes('summary')">
              <page-header>
                <a class="page__header__back-btn" @click="cancelclicked">
                  <icon icon="chevron-left" />
                </a>
                <span>Previous Review Responses</span>
              </page-header>

              <div v-if="display.includes('summary.mostrecent')">
                <div class="tab tab__header azheader">
                  <ul class="tab__list">
                    <li class="tab__item">
                      <span class="tab__link active">Most recent</span>
                    </li>
                    <li class="tab__item">
                      <a class="tab__link" href="#" title="View past results"
                        @click.prevent="displayclicked('summary.previous')" aria-disabled="true">Past results</a>
                    </li>
                  </ul>
                </div>
                <div class="content__inner" v-if="isEmpty(mostrecent_review)">
                  <div class="d-flex justify-content-center">
                    no data available!
                  </div>
                </div>
                <div class="summary-padding" v-if="mostrecent_review">
                  <button v-if="!isEmpty(mostrecent_review)"
                    class="button__default action-btn--danger mb--xs margin-top-10"
                    @click="deletemostrecentreview_clicked">Delete</button>
                  <div v-if="mostrecent_review.prereview_shared">

                    <info-header>
                      <strong v-html="getDateOnlyAsString2(mostrecent_review.reviewdate)"></strong>
                      <span> Pre review</span>

                      <div class="icon--push-right" @click="pastreviewshareclicked(mostrecent_review, 'prereview')">
                        <a class="button__default">
                          <span>Share </span>
                          <icon icon="share" />
                        </a>
                      </div>
                    </info-header>

                    <div v-for="(s, idx) in mostrecent_review.prereview" :key="idx">
                      <accordion v-bind:title="s.name">
                        <div v-for="(s2, idx2) in s.questions" :key="idx2">
                          <div>
                            <div>
                              <p>
                                Question {{ inWords(idx2 + 1) }}
                                <br />
                                <strong>{{ s2.name }}</strong>
                              </p>
                            </div>
                            <div v-for="(a, idx3) in s2.prevalues" :key="idx3">
                              <div v-if="a.selected">
                                <div>
                                  <p>
                                    <span v-if="a.selected">{{ a.name }}</span>
                                  </p>
                                </div>
                                <div class="ta-content" v-if="a.child && a.child.content">
                                  <pre>{{ a.child.content }}</pre>
                                </div>
                              </div>
                              <div class="ta-content" v-if="a.type === 'textarea' && a.content.length > 0
                                ">
                                <pre>{{ a.content }}</pre>
                              </div>
                            </div>
                          </div>
                        </div>
                      </accordion>
                    </div>
                  </div>
                  <div v-if="mostrecent_review.postreview_shared">
                    <info-header>
                      <strong v-html="getDateOnlyAsString2(mostrecent_review.reviewdate)"></strong>
                      <span> Post review</span>
                      <div class="icon--push-right" @click="pastreviewshareclicked(mostrecent_review, 'postreview')">
                        <a class="button__default">
                          <span>Share </span>
                          <icon icon="share" />
                        </a>
                      </div>
                    </info-header>
                    <div v-for="(s, idx) in mostrecent_review.postreview" :key="idx">
                      <accordion v-bind:title="s.name">
                        <div v-for="(s2, idx2) in s.questions" :key="idx2">
                          <div>
                            <div>
                              <p>
                                Question {{ inWords(idx2 + 1) }}
                                <br />
                                <strong>{{ s2.name }}</strong>
                              </p>
                            </div>
                            <div v-for="(a, idx3) in s2.prevalues" :key="idx3">
                              <div v-if="a.selected">
                                <div>
                                  <p>
                                    <span v-if="a.selected">{{ a.name }}</span>
                                  </p>
                                </div>
                                <div class="ta-content" v-if="a.child && a.child.content">
                                  <pre>{{ a.child.content }}</pre>
                                </div>
                              </div>
                              <div class="ta-content" v-if="a.type === 'textarea' && a.content.length > 0
                                ">
                                <pre>{{ a.content }}</pre>
                              </div>
                            </div>
                          </div>
                        </div>
                      </accordion>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="display.includes('summary.previous')">
                <div class="tab tab__header azheader full-width">
                  <ul class="tab__list">
                    <li class="tab__item">
                      <a class="tab__link" href="#" title="View most recent results"
                        @click.prevent="displayclicked('summary.mostrecent')" aria-disabled="true">Most recent</a>
                    </li>
                    <li class="tab__item">
                      <span class="tab__link active">Past results</span>
                    </li>
                  </ul>
                </div>
                <div class="content__inner" v-if="!pastreviews[0].length > 0">
                  <div class="d-flex justify-content-center">
                    no data available!
                  </div>
                </div>
                <div v-if="pastreviews[0].length > 0">
                  <div>
                    <button class="button__default action-btn--danger mb--xs margin-top-10"
                      @click="deletepastreview_clicked">Delete</button>
                    <info-header><strong>View the past results</strong></info-header>
                    <div v-for="(s, idx) in pastreviews[0]" :key="idx">
                      <accordion v-bind:title="s.name">
                        <div v-for="(s2, idx2) in s.questions" :key="idx2">
                          <div>
                            <div>
                              <p>
                                Question {{ inWords(idx2 + 1) }}
                                <br />
                                <strong>{{ s2.name }}</strong>
                              </p>
                            </div>
                            <div class="link-list-group" v-for="(a, idx3) in s2.answers" :key="idx3">
                              <div class="card mb--small" @click.prevent="viewpastreview(a.reviewdate, a.type)">
                                <div class="card-body">
                                  <div class="card-set__item__content">
                                    <p>
                                      <strong>{{ a.name }}</strong>
                                      <br />
                                      {{ a.answer }}
                                    </p>
                                  </div>
                                  <icon icon="chevron-right" />
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </accordion>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- End of Summary -->

            <!-- 
         // View outcomeset
            -->
            <section id="outcomeset" v-if="display.includes('outcomeset')">
              <page-header>
                <a class="page__header__back-btn" @click="cancelclicked">
                  <icon icon="chevron-left" />
                </a>
                <span>Questions for my review</span>
              </page-header>
              <div class="content__inner pb--0">
                <div class="card-set mb--lg" v-if="reviewtype === 'prereview' && selectedoutcomeset.prereview.length > 0">
                  <div class="row">
                    <div class="card-set__title mb--small pr--15 pl--15">
                      <h2>Pre review</h2>
                      <p>Review date : <span v-html="getDateOnlyAsString2(selectedoutcomeset.reviewdate)"></span></p>
                      <div v-if="!selectedoutcomeset.prereview_finalised" @click="shareclicked('prereview')">
                        <a class="button__default">
                          <span>Finalise &amp; Share </span>
                          <icon icon="share" />
                        </a>
                      </div>
                      <div v-if="selectedoutcomeset.prereview_finalised" @click="shareclicked('prereview')">
                        <a class="button__default">
                          <span>Share </span>
                          <icon icon="share" />
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="card-set__title mb--small pr--15 pl--15">
                      <p>
                        There are three groups of 3 or 4 questions. At the end
                        of each group of questions you are prompted to save and
                        return to the full list of questions.
                      </p>
                      <p>
                        Complete all answers and confirm that you want to save
                        your final version. Then you can use the Share button to
                        send to yourself or your healthcare professional.
                      </p>
                    </div>
                  </div>
                  <ul v-if="selectedoutcomeset.prereview.length > 0" class="link-list-group full-width">
                    <li
                      class="link-list-group-item link-list-group-item__inner border-0 no-padding pr--15 pl--15 mb--small"
                      v-for="(q, idx) in selectedoutcomeset.prereview" :key="idx"
                      @click="viewquestionset(q, 'prereview')">
                      <div class="card">
                        <div class="card-body">
                          <div class="card-set__item__content">
                            <p>{{ q.name }}</p>
                            <div class="pb--15">
                              <label>Last updated</label>
                              <br />
                              <span v-html="displaydate(
                                q.lastupdated,
                                selectedoutcomeset.datecreated
                              )
                                "></span>
                            </div>
                          </div>
                          <icon class="icon--push-top" icon="chevron-right" />
                          <div class="card-set__item__footer">
                            <span>{{ q.progress }} answered</span>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="card-set mb--lg" v-if="reviewtype === 'postreview' &&
                  selectedoutcomeset.postreview.length > 0
                  ">
                  <div class="row">
                    <div class="card-set__title mb--small pr--15 pl--15">
                      <h2>Post review</h2>
                      <p>Review date : <span v-html="getDateOnlyAsString2(selectedoutcomeset.reviewdate)"></span></p>
                      <div v-if="!selectedoutcomeset.postreview_finalised" @click="shareclicked('postreview')">
                        <a class="button__default">
                          <span>Finalise &amp; Share </span>
                          <icon icon="share" />
                        </a>
                      </div>
                      <div v-if="selectedoutcomeset.postreview_finalised" @click="shareclicked('postreview')">
                        <a class="button__default">
                          <span>Share </span>
                          <icon icon="share" />
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="card-set__title mb--small pr--15 pl--15">
                      <p>
                        Questions to answer 1-4 weeks after your medicines
                        review. There are three groups of 3 or 4 questions. At
                        the end of each group of questions you are prompted to
                        save and return to the full list of questions.
                      </p>
                      <p>
                        Complete all answers and confirm that you want to save
                        your final version. Then you can use the Share button to
                        send to yourself or your healthcare professional.
                      </p>
                    </div>
                  </div>
                  <ul v-if="selectedoutcomeset.postreview.length > 0" class="link-list-group full-width">
                    <li
                      class="link-list-group-item link-list-group-item__inner border-0 no-padding pr--15 pl--15 mb--small"
                      v-for="(q, idx) in selectedoutcomeset.postreview" :key="idx"
                      @click="viewquestionset(q, 'postreview')">
                      <div class="card">
                        <div class="card-body">
                          <div class="card-set__item__content">
                            <p>{{ q.name }}</p>
                            <div class="pb--15">
                              <label>Last updated</label>
                              <br />
                              <span v-html="displaydate(
                                q.lastupdated,
                                selectedoutcomeset.datecreated
                              )
                                "></span>
                            </div>
                          </div>
                          <icon class="icon--push-top" icon="chevron-right" />
                          <div class="card-set__item__footer">
                            <span>{{ q.progress }} answered</span>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <modal v-bind:class="warning_share_modal_css" title="Warning">
                <div slot="body">
                  <p>{{ warning_share_message }}</p>
                </div>
                <div slot="footer">
                  <ul class="modal__footer__container">
                    <li>
                      <a @click="sharewarningcancelclicked" role="button"
                        class="modal__button modal__button--cancel">Cancel</a>
                    </li>
                    <li v-if="sharewarning_showcontinue">
                      <a @click="sharewarningconfirmedclicked" class="modal__button modal__button--add"
                        role="button">Continue</a>
                    </li>
                  </ul>
                </div>
              </modal>
            </section>

            <!-- // End -->

            <!-- 
         // View question set
            -->

            <section id="questionset" v-if="display.includes('questionset')">
              <page-header>
                <a class="page__header__back-btn" @click="displayclicked('outcomeset')">
                  <icon icon="chevron-left" />
                </a>
                <div class="page__header__text">
                  {{ selectedquestionset.name }}
                </div>
              </page-header>

              <div class="content__inner" v-if="selectedquestionset.questions.length > 0">
                <div class="questions">
                  <div class="question" v-for="(q, idx) in selectedquestionset.questions" :key="idx">
                    <div class="question-body" v-if="idx == qidx">
                      <div class="question__nav mb--small clearfix">
                        <div v-if="idx > 0" class="button float-left" @click="prev_q_clicked">
                          <a class="button__default">
                            <icon icon="chevron-left" /> Prev
                          </a>
                        </div>
                        <div v-if="qidx < selectedquestionset.questions.length - 1" v-bind:class="setNextButtonCss"
                          @click="next_q_clicked">
                          <a class="button__default">
                            Next
                            <icon icon="chevron-right" />
                          </a>
                        </div>
                      </div>

                      <div class="clearfix mb--lg">
                        <!-- <label class="label"
                          >Question {{ inWords(idx + 1) }}</label
                        > -->
                        <label class="label">Question {{ q.qNo }}</label>
                        <div>
                          <p v-if="q.desc.length > 0">{{ q.desc }}</p>
                          <p>{{ q.name }}</p>
                        </div>
                        <div v-if="q.type === 'radiobutton'">
                          <p v-if="q.title != null"><strong>{{ q.title }}</strong></p>
                          <p v-if="q.helptxt != null"><mark>{{ q.helptxt }}</mark></p>
                          <div v-for="(p, idx2) in selectedquestionset.questions[
                            idx
                          ].prevalues" :key="idx2">
                            <ul class="input-field__list full-width">
                              <li v-if="p.type === 'radiobutton'" class="input-field__list__item">
                                <input type="radio" :disabled="reviewtype === 'prereview'
                                    ? selectedoutcomeset.prereview_shared
                                    : selectedoutcomeset.postreview_shared
                                  " v-bind:id="combinetext('q', idx2)" v-bind:name="combinetext('q', idx)" v-on:change="
    radioChange(
      selectedquestionset.questions[idx]
        .prevalues,
      idx2
    )
    " v-bind:value="p.name" :checked="p.selected" />
                                <label v-bind:for="combinetext('q', idx2)">{{ p.name }}
                                  <span v-if="p.desc" class="label-info">
                                    - {{ p.desc }}</span></label>

                                <div class="radio-checkmark"></div>
                              </li>
                            </ul>

                            <div v-if="p.type === 'textarea'">
                              <p></p>
                              <p v-if="p.name.length > 0">
                                <strong>{{ p.name }}</strong>
                              </p>
                              <p v-if="p.desc.length > 0">{{ p.desc }}</p>
                              <textarea class="form-control" v-model="p.content" maxlength="400" :disabled="reviewtype === 'prereview'
                                  ? selectedoutcomeset.prereview_shared
                                  : selectedoutcomeset.postreview_shared
                                " />
                            </div>
                          </div>
                        </div>
                        <div v-if="q.type === 'checkboxlist'">
                          <div v-for="(p, idx2) in selectedquestionset.questions[
                            idx
                          ].prevalues" :key="idx2">
                            <ul class="input-field__list full-width">
                              <li class="input-field__list__item">
                                <input type="checkbox" :disabled="shouldDisable(
                                  selectedquestionset.questions[idx]
                                    .prevalues,
                                  idx2
                                )
                                  " v-bind:id="combinetext('q', idx2)" v-bind:name="combinetext('q', idx2)"
                                  v-on:change="
                                    checkboxChange(
                                      selectedquestionset.questions[idx]
                                        .prevalues,
                                      idx2
                                    )
                                    " v-bind:value="p.name" v-bind:checked="p.selected" />
                                <label v-bind:for="combinetext('q', idx2)">{{ p.name }}
                                  <span v-if="p.desc" class="label-info">
                                    - {{ p.desc }}</span></label>

                                <div class="checkbox-checkmark"></div>
                              </li>
                            </ul>
                            <div class="mt--small mb--small" v-if="p.child && p.selected">
                              <!-- <p v-if="p.desc.length > 0">{{p.desc}}</p> -->
                              <textarea class="form-control" maxlength="400" v-model="p.child.content" :disabled="reviewtype === 'prereview'
                                  ? selectedoutcomeset.prereview_shared
                                  : selectedoutcomeset.postreview_shared
                                " />
                            </div>
                          </div>
                        </div>

                      </div>

                      <div v-if="idx === selectedquestionset.questions.length - 1" class="">
                        <action-button v-bind:class="setSaveButtonCss" class="button--primary">
                          <div @click="savequestionset">Save</div>
                        </action-button>

                        <!-- <action-button class="button--primary">
                          <div @click="displayclicked('outcomeset')">Cancel</div>
                        </action-button> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section v-if="display.includes('endsequence')">
              <page-header>
                <div class="page__header__text">
                  {{ selectedquestionset.name }}
                </div>
              </page-header>
              <div class="content__inner mb--lg">
                <div v-if="selectedquestionset.id === 1.0">
                  <!--Understanding my medicines-->
                  <accordion title="To improve understanding of my medicines">
                    <ul>
                      <li>
                        <p>
                          Try the
                          <a @click.prevent="gotomedicineatoz" href="#" title="View the medicines A-Z page">Medicines
                            A-Z</a>
                          or
                          <a @click.prevent="gotomedicineatoz" href="#"
                            title="More information to help you understand your medicine better">More information</a>
                          to understand your medicines better.
                        </p>
                      </li>
                      <li>
                        <p>
                          Share your responses with your healthcare professional
                          at your medicines review or next consultation.
                        </p>
                      </li>
                    </ul>
                  </accordion>
                  <accordion title="To participate more in decisions about my medicines">
                    <ul>
                      <li>
                        <p>
                          Share your responses with your healthcare professional
                          at your medicines review or next consultation. Let
                          them know what matters to you – be it big or small.
                          This will help staff to work with you to make
                          decisions about your medicines taking into account
                          your personal, individual needs and concerns, wherever
                          possible.
                        </p>
                      </li>
                    </ul>
                  </accordion>
                </div>

                <div v-if="selectedquestionset.id === 2.0">
                  <!--"Medicines and my daily life"-->
                  <accordion title="To manage possible side-effects">
                    <p>
                      Find out more about the benefits and side-effects of your
                      <a @click.prevent="gotomedicineatoz" href="#"
                        title="More information about the benefits and side-effects of your medicines">medicines</a>
                    </p>
                    <ul>
                      <li>
                        <p>
                          Think about how you would like to deal with any side
                          effects.
                        </p>
                      </li>
                      <li>
                        <p>
                          Share the information about possible side-effects with
                          your healthcare professional at your next medicines
                          review or consultation and ask for their advice. This
                          will help you both to discuss possible approaches –
                          for example:
                        </p>
                        <ul>
                          <li>
                            <p>
                              Discuss the balance of benefits, side effects and
                              long˗term effects so that you can make an informed
                              choice
                            </p>
                          </li>
                          <li>
                            <p>Consider adjusting the dosage</p>
                          </li>
                          <li>
                            <p>
                              Consider switching to another medicine with a
                              different risk of side effects
                            </p>
                          </li>
                          <li>
                            <p>
                              Consider what other strategies might be used (for
                              example, changing the timing of taking your
                              medicines).
                            </p>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </accordion>
                  <accordion title="To improve my mood">
                    <ul>
                      <li>
                        <p>
                          If you’re feeling distressed, in a state of despair,
                          suicidal or need emotional support, you can phone
                          Samaritans for free on 116 123. If you’re ill and feel
                          it can’t wait until your GP practice opens you can
                          phone the NHS 24 111 service. For an emergency
                          ambulance phone 999.
                        </p>
                      </li>
                      <li>
                        <p>
                          Share the information about your mood with your GP or
                          other healthcare professional.
                        </p>
                      </li>
                      <li>
                        <p>
                          NHS inform provide a
                          <a @click.prevent="
                            externallinkclicked(
                              'https://www.nhsinform.scot/self-help-guides'
                            )
                            " href="#"
                            title="View self-help guides on NHS Inform (This will open in a new window)">self-help
                            guide</a>
                          for people with mild to moderate symptoms of
                          depression.
                        </p>
                      </li>
                      <li>
                        <p>
                          For information and advice when you're feeling down,
                          you can phone
                          <a @click.prevent="
                            externallinkclicked('https://breathingspace.scot')
                            " href="#"
                            title="Visit Breathing Space for advice when you are feeling down (This will open in a new window)">Breathing
                            Space</a>
                          on <a href="tel://0800838587" title="Call breathing space (This will open in a new window)">0800
                            83 85 87</a>.
                        </p>
                      </li>
                      <li>
                        <p>
                          <a @click.prevent="
                            externallinkclicked(
                              'https://breathingspace.scot/living-life/'
                            )
                            " href="#" title="Vist Living Life (This will open in a new window)">Living Life</a>
                          offers a range of structured psychological
                          interventions and therapies to improve mental health
                          and wellbeing.
                        </p>
                      </li>
                      <li>
                        <p>
                          Search for mental health and wellbeing services using
                          the
                          <a @click.prevent="
                            externallinkclicked(
                              'https://www.nhsinform.scot/scotlands-service-directory'
                            )
                            " href="#"
                            title="View the Scotland service directory on NHS Inform (This will open in a new window)">NHS
                            inform directory</a>
                        </p>
                      </li>
                      <li>
                        <p>
                          <a @click.prevent="
                            externallinkclicked(
                              'https://www.nhsinform.scot/illnesses-and-conditions/mental-health/depression'
                            )
                            " href="#"
                            title="Visit NHS Inform for advice for when you are coping with depression (This will open in a new window)">NHS
                            inform tips for coping with depression</a>
                        </p>
                      </li>
                    </ul>
                  </accordion>
                  <accordion title="To manage effects of medicines on my daily activities">
                    <p>
                      Share your responses with your healthcare professional at
                      your medicines review or next consultation. Let them know
                      how you think your medicines are affecting what matters to
                      you in your daily life. This will help staff to work with
                      you to make decisions about your medicines taking into
                      account your personal, individual needs and concerns,
                      wherever possible.
                    </p>
                    <p>
                      You may find it helpful to use the links in other parts of
                      this section provide to information about side effects,
                      managing mood, pain and mental health issues.
                    </p>
                  </accordion>
                </div>

                <div v-if="selectedquestionset.id === 3.0">
                  <!--Taking my medicines correctly-->
                  <accordion title="To help me take my medicines correctly">
                    <!-- <h4>To help me take my medicines correctly:</h4> -->
                    <p>
                      Think about the problems or concerns that stop you taking
                      your medicines correctly. What support do you think would
                      help? Share these issues and your responses to the questions
                      in this section with your healthcare professional at your
                      medicines review or next consultation.
                    </p>
                    <p>
                      This will help your healthcare professional to discuss what
                      would help you to take your medicines correctly. Possible
                      approaches to discuss include:
                    </p>
                    <ul>
                      <li>
                        <p>Keeping a record when you take your medicines</p>
                      </li>
                      <li>
                        <p>Monitoring your condition</p>
                      </li>
                      <li>
                        <p>Simplifying the dosing</p>
                      </li>
                      <li>
                        <p>Using different packaging for different medicines</p>
                      </li>
                      <li>
                        <p>Using a multi˗compartment medicines dispenser.</p>
                      </li>
                    </ul>
                    <p>If side-effects are an issue, you can:</p>
                    <ul>
                      <li>
                        <p>
                          Find out more about the benefits and side-effects of
                          your
                          <a href="#" @click.prevent="gotomedicineatoz"
                            title="Learn more about the benefits and side-effects of your medicines">medicines</a>.
                        </p>
                      </li>
                      <li>
                        <p>
                          Think about how you would like to deal with any side
                          effects.
                        </p>
                      </li>
                      <li>
                        <p>
                          Share the information about possible side-effects with
                          your healthcare professional at your next medicines
                          review or consultation and ask for their advice. This
                          will help you both to discuss possible approaches – for
                          example:
                        </p>
                        <ul>
                          <li>
                            <p>
                              Discuss the balance of benefits, side effects and
                              long˗term effects so that you can make an informed
                              choice
                            </p>
                          </li>
                          <li>
                            <p>Consider adjusting the dosage</p>
                          </li>
                          <li>
                            <p>
                              Consider switching to another medicine with a
                              different risk of side effects
                            </p>
                          </li>
                          <li>
                            <p>
                              Consider what other strategies might be used (for
                              example, changing the timing of taking your
                              medicines).
                            </p>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </accordion>
                </div>
              </div>
              <div class="button-container">
                <action-button class="button--primary">
                  <div @click="displayclicked('outcomeset')">
                    Return to question list
                    <icon class="icon--push-right" icon="chevron-right" />
                  </div>
                </action-button>
              </div>
            </section>
            <!-- // End -->

            <!-- 
            // Share outcome
            -->
            <section v-if="display.includes('shareoutcome')">
              <page-header>
                <div class="page__header__text">Share</div>
              </page-header>

              <div class="content__inner mb--lg">
                <div class="button__container mb--small">
                  <button class="button__default" @click="displayclicked('privacystatement')"><span class="pr--10">Privacy
                      Statement</span>
                    <icon icon="info-circle" />
                  </button>
                </div>
                <form>
                  <div class="form-group">
                    <p>
                      Email your answers to your healthcare professional, or to
                      yourself to save and print for your review.
                    </p>
                  </div>
                  <div class="form-group">
                    <label for="name"><strong>Name *</strong></label>
                    <input type="text" class="form-control" id="name" v-model="name" @change="validateform"
                      placeholder="Your name" />
                  </div>
                  <div class="form-group">
                    <label for="studyid"><strong>Date of birth *</strong> </label>
                    <a href="#" class="pl--10 ulink" @click="toggleDOBHelp()" title="Tap twice to scroll by decade">How to
                      scroll by decade</a>
                    <p v-if="show_dobhelp" class="help-panel"><span>Tapping on the year twice between the arrows will
                        allow selection from a 10 year range to allow easy selection of DOB</span></p>

                    <vuejs-datepicker v-model="dob" name="dob" format="dd/MM/yyyy" placeholder="dd/MM/yyyy"
                      input-class="form-control dp" @closed="validateform" v-bind:open-date="initdate"
                      :disabled-dates="datestate.disabledDates"></vuejs-datepicker>
                  </div>
                  <div class="isimpathy">
                    <div class="form-check">
                      <input type="checkbox" id="isympathy" v-model="isympathy" @change="isympathychanges"
                        class="form-check-input" />
                      <label for="isympathy"><strong>i-SIMPATHY</strong> (Tick if you are part of this study.)</label>
                    </div>
                    <div class="form-group" v-show="isympathy">
                      <label for="studyid"><strong>Study id *</strong></label>
                      <input type="text" class="form-control" id="studyid" v-model="studyid" placeholder="study id"
                        v-on:blur="validateform" />
                    </div>
                    <div class="form-group" v-show="isympathy">
                      <label for="hpName"><strong>Healthcare professional name *</strong></label>
                      <input type="text" class="form-control" id="hpName" v-model="hpName"
                        placeholder="Healthcare professional name" v-on:blur="validateform" />
                    </div>
                    <div class="form-group" v-show="isympathy">
                      <label for="completedby"><strong>This form was completed by *</strong></label>
                      <select name="completedby" class="form-control" id="completedby" v-model="completedby"
                        v-on:blur="validateform">
                        <option value="" disabled selected hidden>Select item</option>
                        <option value="Patient">Patient</option>
                        <option value="Carer">Carer</option>
                        <option value="Healthcare professional">Healthcare professional</option>
                        <option value="Patient with carer">Patient with carer</option>
                        <option value="Patient with healthcare professional">Patient with healthcare professional</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="studyid"><strong>Recipient emails *</strong></label>
                    <a class="pl--10" @click="toggleEmailHelp()">
                      <icon icon="info-circle" />
                    </a>
                    <p v-if="show_emailhelp" class="help-panel"><span>To add multiple recipients click on +</span></p>

                    <div class="input-group mb-3">
                      <input type="text" v-model="recipiententry" class="form-control" placeholder="name@example.com"
                        aria-label="recipients" />
                      <div class="input-group-append">
                        <button class="btn btn-primary" type="button" @click="addEmailClicked">
                          +
                        </button>
                      </div>
                    </div>
                    <div class="emails">
                      <div class="emailtag" v-for="(e, idx) in recipients" @click="removeemail(idx)" :key="idx">
                        <span class="emailname">{{ e }}</span>
                        <span class="deletex">x</span>
                      </div>
                    </div>
                  </div>
                  <div v-if="validation_message.length > 0" class="form-group">
                    <ul class="error">
                      <li v-for="(e, idx) in validation_message" :key="idx">
                        {{ e }}
                      </li>
                    </ul>
                  </div>
                </form>
              </div>
              <div class="button-container">
                <action-button class="button--primary mb--xs">
                  <div @click="sendshareclicked">Submit</div>
                </action-button>
                <action-button class="button--secondary">
                  <div @click="sharecancelclicked">Cancel</div>
                </action-button>
              </div>
              <modal v-bind:class="share_confirm_css" title="Share review">
                <div slot="body">
                  Are you sure you want to share these review questions?
                </div>
                <div slot="footer">
                  <ul class="modal__footer__container">
                    <li>
                      <a @click="shareconfirmcancelclicked" role="button"
                        class="modal__button modal__button--cancel">Cancel</a>
                    </li>
                    <li>
                      <a @click="sendshareconfirmedclicked" class="modal__button modal__button--add"
                        role="button">Confirm</a>
                    </li>
                  </ul>
                </div>
              </modal>
            </section>

            <!-- Privacy Statement -->

            <section id="privacystatement" v-if="display.includes('privacystatement')">
              <page-header>
                <a class="page__header__back-btn" @click="displayclicked('shareoutcome')">
                  <icon icon="chevron-left" />
                </a>
                <span>Privacy Statement</span>
              </page-header>
              <div class="content__inner">
                <p>This app collects information that you provide about the impact of your medicines and medicines review.
                  This includes your name and date of birth and your Study ID if you are part of the i-SIMPATHY study.</p>
                <p>The information is stored on your mobile device and it is your responsibility to apply your own
                  security measures to your device – e.g. password protection. If you choose the “Share” option within the
                  app, this information is emailed securely to your chosen healthcare professional, who will review it and
                  store it securely with your other health records. You have the right to request access at any time to
                  see how this information is stored and can ask that the information is amended or removed. Your local
                  practice will provide details of how you can request access to your health records.</p>
                <p>
                  If you are participating in the i-SIMPATHY study, your pharmacist uploads the information you provide to
                  a database to enable analysis of the impact of medicines review. Any information that could identify you
                  personally will be excluded from the upload process, so that it is completely anonymous.</p>
                <p>If you are unable to complete the responses to the questions on the app yourself, your healthcare
                  professional may use the app to enter the responses in consultation with you. If the healthcare
                  professional is using their own device, they are required to delete the record of responses after
                  emailing it to an NHS email address.</p>
              </div>
            </section>

            <!-- // End -->
          </div>
        </div>
      </div>
    </div>
    <MedicineAtoZList v-if="display.includes('medicineatoz')" returnview="endsequence"
      @returnToclicked="displayclicked($event)" />
  </main>
</template>

<script>
//import AES  from 'crypto-js/aes';
//import enc from 'crypto-js/enc-utf8';
import CryptoJS from "crypto-js";
import axios from "axios";
import { Outcomeset } from "../../../App_Data/outcomesets.json";
//import { pharmacistemail } from "../../../App_Data/outcomesets.json";
import helper from "../../../helpers/helper.js";
import pdfhelper from "../../../helpers/pdfhelper.js";
import vuejsDatepicker from "vuejs-datepicker";
import images from '@/helpers/encodedImages.js';

const INPROGRESS = "In progress";
const NOT_STARTED = "Not started";
const FINALISED = "Finalised";
const COMPLETED = "Completed";
const INAPP = "--INAPP--";

const DISPLAY_MYREVIEWS = "myreviews";
const DISPLAY_MEDICINES_ATOZ = "medicineatoz";
const DISPLAY_ENDOFSEQUENCE = "endsequence";
const DISPLAY_SUMMARY_MOSTRECENT = "summary.mostrecent";
const DISPLAY_OUTCOMESET = "outcomeset";
const DISPLAY_SHARE_OUTCOME = "shareoutcome";
const DISPLAY_QUESTIONSET = "questionset";

const MODAL_ACTIVE_CSS = "modal__container--active";
const BUTTON_DISABLE_CSS = "button--disabled";



export default {
  name: "MyReview",
  mounted() {
    setTimeout(
      function () {
        let bodyhtml = document.querySelector("body").innerHTML;
        if (!bodyhtml.includes(INAPP)) {
          this.isapp = false;
          this.rootpath = "/";
        }
      }.bind(this),
      500
    );
    //let _d = new Date();
    this.initdate = new Date(1945, 0);//new Date(_d.getFullYear() - 70, 0);
    this.getreview();
    //this.loadtestdata();
  },
  data() {
    return {
      images: images,
      encrypted: "",
      unencrypted: "",
      isapp: true,
      rootpath: "",
      name: "",
      dob: "",
      isympathy: false,
      studyid: "",
      hpName: "",
      completedby: "",
      recipiententry: "",
      recipients: [{ emaill: "mmurray@tactuum.com", name: "Matthew Murray" }],
      validation_message: [],
      reviewtype: "",
      newreviewdate: null,
      newreviewdate_error: "",
      newreviewdate_modal_css: "",
      warning_hasnotstarted_modal_css: "",
      warning_hasonefinalised_modal_css: "",
      warning_deletereview_modal_css: "",
      warning_deletepastreview_modal_css: "",
      warning_deletemostrecentreview_modal_css: "",
      warning_deletetoppastreview_modal_css: "",
      warning_share_modal_css: "",
      warning_share_message: "",
      confirm_deleted_message_modal_css: "",
      confirm_emailsent_modal_css: "",
      emailsent_message: "",
      deletewarning_showcontinue: false,
      sharewarning_showcontinue: false,
      show_emailhelp: false,
      show_dobhelp: false,
      display: DISPLAY_MYREVIEWS,
      outcomeset: Outcomeset,
      selectedoutcomeset: {},
      selectedquestionset: {},
      myreview: { currentreview: [], previousreviews: [] },
      qidx: 0,
      next_idx: 1,
      prev_idx: 0,
      selected_count: 0,
      mostrecent_review: {},
      pastreviews: [],
      next3_reviews: [],
      share_confirm_css: "",
      share_preview_confirm_css: "",
      pdfhtml: "",
      datestate: {
        disabledDates: {
          customPredictor: function (date) {
            let _currentdate = new Date();
            let _year0 = _currentdate.getFullYear() - 110;
            let _year1 = _currentdate.getFullYear();
            let _year = date.getFullYear();
            if (_year <= _year0 || _year >= _year1) {
              return true;
            }
          },
        },
      },
      initdate: {},
    };
  },
  components: {
    vuejsDatepicker,
  },
  computed: {
    sortedArray() {
      return this.myreview.previousreviews
        .slice(0)
        .sort((a, b) => {
          return b.reviewdate - a.reviewdate;
        })
        .reverse();
    },
    setNextButtonCss() {
      let _cssclass = "button float-right button--disabled";
      let answered_current =
        this.selectedquestionset.questions[this.qidx].prevalues.filter(
          (p) => p.selected
          //(p) => p.selected || (p.content && p.content.length > 0)
        ).length > 0;
      if (answered_current) {
        _cssclass = "button float-right";
      }
      return _cssclass;
    },
    setSaveButtonCss() {
      let _cssclass = BUTTON_DISABLE_CSS;
      let answered_current =
        this.selectedquestionset.questions[this.qidx].prevalues.filter(
          //(p) => p.selected || (p.content && p.content.length > 0)
          (p) => p.selected
        ).length > 0;
      let _shared =
        this.reviewtype === "prereview"
          ? this.selectedoutcomeset.prereview_shared
          : this.selectedoutcomeset.postreview_shared;
      if (answered_current && !_shared) {
        _cssclass = "button";
      }
      return _cssclass;
    },
    setPrereviewShareButtonCss() {
      let _cssclass = BUTTON_DISABLE_CSS;
      if (
        this.selectedoutcomeset.prereviewstatus === COMPLETED ||
        this.selectedoutcomeset.prereviewstatus === FINALISED
      ) {
        _cssclass = "";
      }
      return _cssclass;
    },
    setPostreviewShareButtonCss() {
      let _cssclass = BUTTON_DISABLE_CSS;
      if (
        this.selectedoutcomeset.postreviewstatus === COMPLETED ||
        this.selectedoutcomeset.prereviewstatus === FINALISED
      ) {
        _cssclass = "";
      }
      return _cssclass;
    }
  },
  methods: {
    ...helper,
    toggleDOBHelp() {
      if (this.show_dobhelp) {
        this.show_dobhelp = false;
      }
      else {
        this.show_dobhelp = true;
      }
      return false;
    },
    toggleEmailHelp() {
      if (this.show_emailhelp) {
        this.show_emailhelp = false;
      }
      else {
        this.show_emailhelp = true;
      }
    },
    gotomedicineatoz() {
      this.displayclicked(DISPLAY_MEDICINES_ATOZ);
    },
    returnfromatozclicked() {
      this.displayclicked(DISPLAY_ENDOFSEQUENCE);
    },
    externallinkclicked(url) {
      if (this.isapp) {
        let d = { title: "", nodeid: -1, href: "", target: "" };
        d.href = url;
        d.target = "_blank";
        window.Native("dataCallback", d);
        return false;
      } else {
        let win = window.open(url, "_blank");
        win.focus();
      }
    },
    applypath(path) {
      return this.rootpath + path;
    },
    isEmpty(obj) {
      return helper.isEmpty(obj);
    },
    validateemail(email) {
      const re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    removeemail(idx) {
      this.recipients.splice(idx, 1);
    },
    resetform() {
      this.name = "";
      this.dob = "";
      (this.studyid = ""), (this.recipiententry = "");
      this.recipients = [];
      this.validation_message = [];
    },
    addEmailClicked() {
      let rep = this.recipiententry.trim();
      if (this.validateemail(rep)) {
        this.recipiententry = "";
        let _eexist = false;
        this.recipients.forEach((e) => {
          if (rep.toLowerCase() === e.toLowerCase()) {
            _eexist = true;
          }
        });
        if (!_eexist) {
          this.recipients.push(rep);
        }
      }
      this.validateform();
    },
    getAnswer(pv) {
      let _ans = [];
      pv.forEach((v) => {
        if (v.selected) {
          _ans.push(v.name);
          if (v.child && v.child.content && v.child.content.length > 0) {
            _ans.push(v.child.content);
          }
        }
        if (v.type === "textarea" && v.content && v.content.length > 0) {
          _ans.push(v.content);
        }
      });
      return _ans.join(",");
    },
    getAnswer2(pv) {
      let _ans = [];
      pv.forEach((v) => {
        if (v.selected) {
          _ans.push(v.name);
          if (v.child && v.child.content && v.child.content.length > 0) {
            _ans.push(v.child.content);
          }
        }
        if (v.type === "textarea" && v.content && v.content.length > 0) {
          _ans.push(" Freetext response : " + v.content);
        }
      });
      return _ans.join(",");
    },
    displaysummaryclicked() {


      if (this.sortedArray && this.sortedArray.length > 0) {
        let _f = this.sortedArray[0];
        this.mostrecent_review = _f;
      }

      /*
      let questionsettitles = [];

      if (this.sortedArray && this.sortedArray.length > 0) {
        for(let i=0;i<this.sortedArray.length;i++)
        {
          let s = this.sortedArray[i];
          if(s && s.prereview && s.prereview_shared)
          {
            s.prereview.forEach((pr) => {
              if (questionsettitles.filter((q) => q.name === pr.name) == 0) {
                questionsettitles.push({
                  name: pr.name,
                  questions: [],
                });
              }
            });
          }
          
          if(s && s.length > 0 && s.postreview)
          {
            s.postreview.forEach((pr) => {
            if (
              questionsettitles.filter((q) => q.name === pr.name).length == 0
            ) {
              questionsettitles.push({
                name: pr.name,
                questions: [],
              });
            }
          });
          }
          
        }


        //build array of questions
        questionsettitles.forEach((sect) => {
          this.sortedArray.forEach((r) => {
            r.prereview.forEach((pr) => {
              if (sect.name === pr.name) {
                pr.questions.forEach((q) => {
                  if (
                    sect.questions.filter((q2) => q2.name === q.name).length ==
                    0
                  ) {
                    sect.questions.push({
                      name: q.name,
                      answers: [],
                    });
                  }
                });
              }
            });
            r.postreview.forEach((pr) => {
              if (sect.name === pr.name) {
                pr.questions.forEach((q) => {
                  if (
                    sect.questions.filter((q2) => q2.name === q.name).length ==
                    0
                  ) {
                    sect.questions.push({
                      name: q.name,
                      answers: [],
                    });
                  }
                });
              }
            });
          });
        });

        //populate array of questions
        questionsettitles.forEach((sect) => {
          sect.questions.forEach((q) => {
            this.sortedArray.forEach((r) => {
              if (r.prereview_shared) {
                r.prereview.forEach((pr) => {
                  if (sect.name === pr.name) {
                    pr.questions.forEach((q2) => {
                      if (q.name === q2.name) {
                        let ans = this.getAnswer(q2.prevalues);
                        q.answers.push({
                          reviewdate: r.reviewdate,
                          type:"prereview",
                          name: this.getDateOnlyAsString2(r.reviewdate) + " - Pre",
                          answer: ans,
                        });
                      }
                    });
                  }
                });
              }

              if (r.postreview_shared) {
                r.postreview.forEach((pr) => {
                  if (sect.name === pr.name) {
                    pr.questions.forEach((q2) => {
                      if (q.name === q2.name) {
                        let ans = this.getAnswer(q2.prevalues);
                        q.answers.push({
                          reviewdate: r.reviewdate,
                          type:"postreview",
                          name: this.getDateOnlyAsString2(r.reviewdate) + " - Post",
                          answer: ans,
                        });
                      }
                    });
                  }
                });
              }
            });
          });
        });
      }
      this.pastreviews = questionsettitles;
      */

      //MOST RECENT
      if (this.sortedArray && this.sortedArray.length > 0) {
        var filtered = this.sortedArray.filter(x => x !== 'undefined');
        for (let i = 0; i < filtered.length; i++) {
          if (typeof filtered[i] !== 'undefined') {
            let _f = filtered[i];
            this.mostrecent_review = _f;
            break;
          }
        }
      }

      let questionsettitles = [];
      questionsettitles = this.getallquestions(this.sortedArray);
      this.pastreviews = questionsettitles;
      this.displayclicked(DISPLAY_SUMMARY_MOSTRECENT);
    },
    displayclicked(display) {
      this.show_emailhelp = false;
      this.show_dobhelp = false;
      this.display = display;
      if (display === DISPLAY_MYREVIEWS) {
        this.archivereview();
        if (this.sortedArray && this.sortedArray.length > 0) {
          var filtered = this.sortedArray.filter(x => x !== 'undefined');
          for (let i = 0; i < filtered.length; i++) {
            if (typeof filtered[i] !== 'undefined') {
              let _f = filtered[i];
              this.mostrecent_review = _f;
              break;
            }
          }
        }
      }
    },
    archivereview() {
      if (
        this.myreview.currentreview.length > 0
        && this.myreview.currentreview[0] != null
        && this.myreview.currentreview[0].prereview_finalised
        && this.myreview.currentreview[0].postreview_finalised
      ) {
        if (typeof this.myreview.currentreview[0] !== 'undefined') {
          this.myreview.previousreviews.push(this.myreview.currentreview[0]);
        }

        this.myreview.currentreview = [];
        this.savereview();
      }
    },
    cancelclicked() {
      this.displayclicked(DISPLAY_MYREVIEWS);
      this.qidx = 0;
    },
    next_q_clicked() {
      if (this.selectedquestionset.questions.length - 1 > this.qidx) {
        let answered_current =
          this.selectedquestionset.questions[this.qidx].prevalues.filter(
            (p) => p.selected || (p.content && p.content.length > 0)
          ).length > 0;
        if (answered_current) {
          this.prev_idx = this.qidx;
          let _p = this.selectedquestionset.questions[this.qidx].prevalues.find(
            (p) => p.selected
          );
          if (_p && _p.next) {
            this.selectedquestionset.questions.forEach((q, i) => {
              if (q.id === _p.next) {
                this.prev_idx = this.qidx;
                this.qidx = i;
              }
            });
          } else {
            this.prev_idx = this.qidx;
            this.qidx++;
          }
        }
      }
    },
    prev_q_clicked() {
      if (this.prev_idx > -1) {
        if (this.qidx == this.prev_idx) {
          this.qidx--;
        } else {
          this.qidx = this.prev_idx;
        }
        if (this.qidx - 1 > -1) {
          this.prev_idx = this.qidx - 1;
        }
      }
    },
    radioChange(prevalues, idx) {
      let _hasnext = false;
      prevalues.forEach((el, i) => {
        if (el.next) {
          _hasnext = true;
        }
        if (i === idx) {
          el.selected = true;
        } else {
          el.selected = false;
        }
      });
      if (_hasnext) {
        this.resetquestionsAfterCurrent();
      }
      this.updateprogress();
    },
    checkboxChange(prevalues, idx) {
      let _maxcount = -1;
      if (this.selectedquestionset.questions[this.qidx].max_selected_values) {
        _maxcount = this.selectedquestionset.questions[this.qidx]
          .max_selected_values;
      }
      let _hasnext = false;
      let _tempmaxcount = 0;
      prevalues.forEach((el, i) => {
        if (el.next) {
          _hasnext = true;
        }
        if (i === idx) {
          if (el.selected) {
            el.selected = false;
          } else {
            el.selected = true;
          }
        }
      });
      if (_maxcount > 0) {
        prevalues.forEach((el) => {
          if (el.selected) {
            _tempmaxcount++;
          }
          if (_tempmaxcount > _maxcount) {
            el.selected = false;
          }
        });
      }

      if (_hasnext) {
        this.resetquestionsAfterCurrent();
      }
      this.selected_count = _tempmaxcount;
      this.updateprogress();
    },
    isympathychanges() {
      if (!this.isympathy) {
        this.studyid = "";
      }
      this.validateform();
    },
    shouldDisable(prevalues, idx) {
      //console.log(prevalues);
      //console.log(idx);

      let _notdisabled =
        this.reviewtype === "prereview"
          ? this.selectedoutcomeset.prereview_shared
          : this.selectedoutcomeset.postreview_shared;
      let _maxcount = -1;
      if (!_notdisabled) {
        if (this.selectedquestionset.questions[this.qidx].max_selected_values) {
          _maxcount = this.selectedquestionset.questions[this.qidx]
            .max_selected_values;
          let _tempcount = 0;
          this.selectedquestionset.questions[this.qidx].prevalues.forEach(
            (p) => {
              if (p.selected) {
                _tempcount++;
              }
            }
          );
          if (_tempcount >= _maxcount) {
            _notdisabled = true;
            this.selectedquestionset.questions[this.qidx].prevalues.forEach(
              (p, idx2) => {
                if (p.selected && idx === idx2) {
                  _notdisabled = false;
                }
              }
            );
          }
        }
      }
      //_disable = true;
      return _notdisabled;
    },
    resetquestionsAfterCurrent() {
      for (
        let i = this.qidx + 1;
        i < this.selectedquestionset.questions.length;
        i++
      ) {
        this.selectedquestionset.questions[i].prevalues.forEach((p) => {
          if (p.type === "texarea") {
            p.content = "";
          }
          if (p.type === "radiobutton" || p.type === "checkbox") {
            p.selected = false;
            if (p.child && p.child.type === "textarea") {
              p.child.content = "";
            }
          }
        });
      }
    },
    updateprogress() {
      if (
        this.myreview.currentreview &&
        this.myreview.currentreview.length > 0
      ) {
        //this.myreview.currentreview[0].forEach((el) => {
        let el = this.myreview.currentreview[0];
        let _pretotal = el.prereview.length;
        let _prereviewcompleted = 0;
        let _totalprereviewquestionsanswered = 0;
        el.prereview.forEach((pre) => {
          let _pretotalquestions = pre.questions.length;
          let _cnt1 = 0;
          pre.questions.forEach((q) => {
            let _qanswered = false;
            q.prevalues.forEach((p) => {
              if (p.type === "textarea" && p.content.length > 0) {
                _qanswered = true;
              } else if (
                (p.type === "radiobutton" || p.type === "checkbox") &&
                p.selected
              ) {
                _qanswered = true;
              }
            });
            if (_qanswered) {
              _cnt1++;
              _totalprereviewquestionsanswered++;
            }
          });
          pre.progress = _cnt1 + "/" + _pretotalquestions;
          if (pre.completed) {
            pre.progress = _cnt1 + "/" + _cnt1;
            //(_cnt1===_pretotalquestions)
            _prereviewcompleted++;
          }
        });

        if (el.prereviewstatus != FINALISED) {
          if (_pretotal === _prereviewcompleted) {
            el.prereviewstatus = COMPLETED;
            //el.prereviewstatus = "completed";
          } else if (_totalprereviewquestionsanswered > 0) {
            el.prereviewstatus = INPROGRESS;
            //el.prereviewstatus = INPROGRESS;
          } else {
            el.prereviewstatus = NOT_STARTED;
          }
        }


        let _posttotal = el.postreview.length;
        let _postreviewcompleted = 0;
        let _totalpostreviewquestionsanswered = 0;
        el.postreview.forEach((po) => {
          let _posttotalquestions = po.questions.length;
          let _cnt2 = 0;
          po.questions.forEach((q) => {
            let _qanswered = false;
            q.prevalues.forEach((p) => {
              /*
              if (p.type === "textarea" && p.content.length > 0) {
                _qanswered = true;
              } else if (
                (p.type === "radiobutton" || p.type === "checkbox") &&
                p.selected
              ) {
                _qanswered = true;
              }
              */
              if (
                (p.type === "radiobutton" || p.type === "checkbox") &&
                p.selected
              ) {
                _qanswered = true;
              }
            });
            if (_qanswered) {
              _cnt2++;
              _totalpostreviewquestionsanswered++;
            }
          });
          po.progress = _cnt2 + "/" + _posttotalquestions;
          if (po.completed) {
            //(_cnt2===_posttotalquestions)
            po.progress = _cnt2 + "/" + _cnt2;
            _postreviewcompleted++;
          }
        });

        if (el.postreviewstatus != FINALISED) {
          if (_posttotal === _postreviewcompleted) {
            el.postreviewstatus = COMPLETED;
          } else if (_totalpostreviewquestionsanswered > 0) {
            el.postreviewstatus = INPROGRESS;
          } else {
            el.postreviewstatus = NOT_STARTED;
          }
        }

        //});
      }
    },
    viewpastreview(reviewdate, reviewtype) {
      let _r = this.myreview.previousreviews.find(r => r.reviewdate === reviewdate);
      if (_r != null) {
        this.viewoutcomesset(_r, reviewtype);
      }
    },
    pastreviewshareclicked(review, reviewtype) {
      let _r = this.myreview.previousreviews.find(r => r.reviewdate === review.reviewdate);
      if (_r != null) {
        this.viewoutcomesset(_r, reviewtype);
        this.shareclicked(reviewtype);
      }
    },
    viewoutcomesset(q, reviewtype) {
      this.reviewtype = reviewtype;
      this.selectedoutcomeset = q;
      this.displayclicked(DISPLAY_OUTCOMESET);
      this.qidx = 0;
    },
    viewquestionset(q, reviewtype) {
      this.reviewtype = reviewtype;
      this.selectedquestionset = q;
      this.displayclicked(DISPLAY_QUESTIONSET);
      this.qidx = 0;
    },
    resetmodal() {
      this.confirm_emailsent_modal_css = "";
      this.emailsent_message = "";
      this.newreviewdate_error = "";
      this.newreviewdate_modal_css = "";
      this.warning_hasnotstarted_modal_css = "";
      this.warning_hasonefinalised_modal_css = "";
      this.warning_share_modal_css = "";
      this.share_confirm_css = "";
      this.show_emailhelp = false;
      this.show_dobhelp = false;
    },
    startcreateoutcomesset_clicked() {
      if (!this.myreview.currentreview || this.myreview.currentreview.length === 0) {
        this.newreviewdate = null;
        this.newreviewdate_modal_css = MODAL_ACTIVE_CSS;
      } else {
        let _hasfinalised = (this.myreview.currentreview[0].prereviewstatus === FINALISED || this.myreview.currentreview[0].postreviewstatus === FINALISED) ? true : false;
        if (_hasfinalised) {
          this.warning_hasonefinalised_modal_css = MODAL_ACTIVE_CSS;
        }
        else {
          this.warning_hasnotstarted_modal_css = MODAL_ACTIVE_CSS;
        }
      }


    },
    createreviewcancelclicked() {
      this.newreviewdate = null;
      this.newreviewdate_error = "";
      this.resetmodal();
    },
    continuehasfinalisedconfirmedclicked() {
      this.resetmodal();
      this.newreviewdate = null;
      this.newreviewdate_modal_css = MODAL_ACTIVE_CSS;
    },
    createreviewconfirmedclicked() {
      if (this.newreviewdate) {
        this.newreviewdate_modal_css = "";
        this.newreviewdate_error = "";
        if (typeof this.myreview.currentreview[0] !== 'undefined') {
          this.myreview.previousreviews.push(this.myreview.currentreview[0]);
        }
        this.myreview.currentreview = [];
        this.createoutcomesset();
        this.newreviewdate = null;
      } else {
        this.newreviewdate_error = "Please enter a review date";
      }
    },
    validatenewreviewdate() {
      if (this.newreviewdate) {
        this.newreviewdate_error = "";
      } else {
        this.newreviewdate_error = "Please enter a review date";
      }
    },
    displaystatus(s) {
      let _status = s;
      if (s === COMPLETED) {
        _status = INPROGRESS;
      }
      return _status;
    },
    createoutcomesset() {
      let stroc = JSON.stringify(this.outcomeset);
      let _currentitme = helper.getcurrentdate();
      let oc = JSON.parse(stroc);
      oc.name = this.newreviewdate;
      oc.reviewdate = this.newreviewdate;
      oc.prereviewstatus = NOT_STARTED;
      oc.postreviewstatus = NOT_STARTED;
      oc.datecreated = _currentitme;
      oc.lastupdated = _currentitme;
      oc.lastupdated_prereview = _currentitme;
      oc.lastupdated_postreview = _currentitme;
      oc.sortbydate = helper.getcurrentdateasnumber();
      this.myreview.currentreview = [];
      this.myreview.currentreview.push(oc);
      //this.seedid();
      this.updateprogress();
      this.savereview();
    },
    seedid() {
      let cnt = 10000;
      if (this.myreview.currentreview && this.myreview.currentreview.length) {
        this.myreview.currentreview[0].forEach((o) => {
          o.id = cnt++;
          o.prereview.forEach((prereview) => {
            prereview.id = cnt++;
            prereview.questions.forEach((q) => {
              q.id = cnt++;
              q.prevalues.forEach((p2) => {
                p2.id = cnt++;
              });
            });
          });
          o.postreview.forEach((postreview) => {
            postreview.id = cnt++;
            postreview.questions.forEach((q) => {
              q.id = cnt++;
              q.prevalues.forEach((p2) => {
                p2.id = cnt++;
              });
            });
          });
        });
      }
    },
    getreview(_callback) {
      let _me = this;
      if (!window.flutter_inappwebview.callHandler) { //this instantiates some methods so that on android the loading works
        window.flutter_inappwebview.callHandler = function () {
          var _callHandlerID = setTimeout(function () { });
          window.flutter_inappwebview._callHandler(arguments[0], _callHandlerID, JSON.stringify(Array.prototype.slice.call(arguments, 1)));
          return new Promise(function (resolve, reject) {
            console.log(typeof (reject)); //this line is just to avoid unused variable error
            window.flutter_inappwebview[_callHandlerID] = resolve;
          });
        };
      }
      window.flutter_inappwebview.callHandler('GET:POLYREVIEW').then(function (result) {
        console.log("getting data from poly q4mr");
        console.log("data is "+result.length+ " long");
        let res0 = atob(result);
        let res1 = JSON.parse(res0);
        console.log(res1)
        if (res0 === "%5B%5D") {
          _me.myreview = {
            previousreviews: [],
            currentreview: [],
          };
        }
        else {
          _me.myreview = res1;
          _me.displaysummaryclicked();
          _me.displayclicked(DISPLAY_MYREVIEWS);
        }
        _me.updateprogress();
        _me.clearnull();
      }).catch((error) => {
        console.log('failed' + error);
        _callback({});
      });
    },
    // getreview() {
    //   let _me = this;
    //   axios
    //     .get("https://127.0.0.1:8989/datastore/get/myreview")
    //     .then((response) => {
    //       if (response.status == 200) {
    //         if (response.data.length > 0) {
    //           let res0 = atob(response.data);
    //           let res1 = JSON.parse(decodeURIComponent(res0));
    //           if(res0 === "%5B%5D")
    //           {
    //             _me.myreview = {
    //               previousreviews: [],
    //               currentreview: [],
    //             };
    //           }
    //           else
    //           {
    //             _me.myreview = res1;
    //             _me.displaysummaryclicked();
    //             _me.displayclicked(DISPLAY_MYREVIEWS);
    //           }
    //           _me.updateprogress();
    //           _me.clearnull();
    //         }
    //       }
    //     });
    // },
    savequestionset() {
      let answered_current =
        this.selectedquestionset.questions[this.qidx].prevalues.filter(
          //(p) => p.selected || (p.content && p.content.length > 0)
          (p) => p.selected
        ).length > 0;
      let _shared =
        this.reviewtype === "prereview"
          ? this.selectedoutcomeset.prereview_shared
          : this.selectedoutcomeset.postreview_shared;
      if (answered_current && !_shared) {
        let currentdatetime = helper.getcurrentdate();
        this.selectedoutcomeset.lastupdated = currentdatetime;
        // let prog =
        //   this.selectedquestionset.questions.length +
        //   "/" +
        //   this.selectedquestionset.questions.length;

        //if (this.selectedquestionset.progress === prog) {
        //this.reviewtype = reviewtype;
        if (this.reviewtype === "prereview") {
          this.selectedoutcomeset.lastupdated_prereview = currentdatetime;
        } else {
          this.selectedoutcomeset.lastupdated_postreview = currentdatetime;
        }
        this.selectedquestionset.lastupdated = currentdatetime;
        this.selectedquestionset.completed = true;
        this.savereview();
        if (this.selectedquestionset.endofsequence) {
          this.displayclicked(DISPLAY_ENDOFSEQUENCE);

        } else {
          this.cancelclicked();
        }
        this.updateprogress();
        //}
      }
    },
    savereview() {
      console.log("savereview called");
      let data1 = JSON.stringify(this.myreview);
      let data2 = btoa(data1);
      let data0 = data2;
      console.log("data generated");
      console.log(data0);
      //alert("SAVE:POLYREVIEW:" + data0);
      if (!window.flutter_inappwebview.callHandler) { //this instantiates some methods so that on android the loading works
        window.flutter_inappwebview.callHandler = function () {
          var _callHandlerID = setTimeout(function () { });
          window.flutter_inappwebview._callHandler(arguments[0], _callHandlerID, JSON.stringify(Array.prototype.slice.call(arguments, 1)));
          return new Promise(function (resolve, reject) {
            console.log(typeof (reject)); //this line is just to avoid unused variable error
            window.flutter_inappwebview[_callHandlerID] = resolve;
          });
        };
      }
      window.flutter_inappwebview.callHandler('SAVE:POLYREVIEW', data0).then(function (result) {
        return result;
      }).catch((error) => {
        console.log('failed' + error);
      });

    },
    shareclicked(reviewtype) {
      this.resetform();
      this.warning_share_message = "";
      this.reviewtype = reviewtype;

      if (this.reviewtype === "prereview" && this.selectedoutcomeset.prereviewstatus === NOT_STARTED) {
        this.warning_share_message = "You are not able to finalise and share your answers until you have answered all questions.";
        this.sharewarning_showcontinue = false;
      }
      if (this.reviewtype === "postreview" && this.selectedoutcomeset.postreviewstatus === NOT_STARTED) {
        this.warning_share_message = "You are not able to finalise and share your answers until you have answered all questions.";
        this.sharewarning_showcontinue = false;
      }
      if (this.reviewtype === "prereview" && this.selectedoutcomeset.prereviewstatus === INPROGRESS) {
        this.warning_share_message = "You are not able to finalise and share your answers until you have answered all questions.";
        this.sharewarning_showcontinue = false;
      }
      if (this.reviewtype === "postreview" && this.selectedoutcomeset.postreviewstatus === INPROGRESS) {
        this.warning_share_message = "You are not able to finalise and share your answers until you have answered all questions.";
        this.sharewarning_showcontinue = false;
      }
      if (this.reviewtype === "prereview" && this.selectedoutcomeset.prereviewstatus === COMPLETED) {
        this.warning_share_message = "Are you sure you want to save a final version of your answers?  You will no longer be able to edit them.";
        this.sharewarning_showcontinue = true;
      }
      if (this.reviewtype === "postreview" && this.selectedoutcomeset.postreviewstatus === COMPLETED) {
        this.warning_share_message = "Are you sure you want to save a final version of your answers?  You will no longer be able to edit them.";
        this.sharewarning_showcontinue = true;
      }
      this.warning_share_modal_css = MODAL_ACTIVE_CSS;
      if (this.reviewtype === "prereview" && this.selectedoutcomeset.prereviewstatus === FINALISED) {
        this.resetmodal();
        this.resetform();
        this.displayclicked(DISPLAY_SHARE_OUTCOME);
      }

      if (this.reviewtype === "postreview" && this.selectedoutcomeset.postreviewstatus === FINALISED) {
        this.resetmodal();
        this.resetform();
        this.displayclicked(DISPLAY_SHARE_OUTCOME);
      }


    },
    sharewarningcancelclicked() {
      this.resetform();
      this.resetmodal();
    },
    sharewarningconfirmedclicked() {
      this.resetform();

      if (this.reviewtype === "prereview" && this.selectedoutcomeset.prereviewstatus === FINALISED) {
        this.sharewarning_showcontinue = true;
        this.resetmodal();
        this.resetform();
        this.displayclicked(DISPLAY_SHARE_OUTCOME);
      }
      if (this.reviewtype === "prereview" && this.selectedoutcomeset.prereviewstatus === COMPLETED) {
        this.selectedoutcomeset.prereviewstatus = FINALISED;
        this.selectedoutcomeset.prereview_shared = true;
        if (this.myreview.currentreview.length > 0 && this.myreview.currentreview[0] != null) {
          this.myreview.currentreview[0].prereviewstatus = FINALISED;
          this.myreview.currentreview[0].prereview_finalised = true;
        }

        this.sharewarning_showcontinue = true;
        this.warning_share_message = "Your answers have been saved. Click on 'Continue' to email your answers now Or click on Cancel to email later.";
        //"Your answers have been saved. Click on 'Continue' to email your answers now or use the Share button to email later.";
      }


      if (this.reviewtype === "postreview" && this.selectedoutcomeset.postreviewstatus === FINALISED) {
        this.sharewarning_showcontinue = true;
        this.resetmodal();
        this.resetform();
        this.displayclicked(DISPLAY_SHARE_OUTCOME);
      }
      if (this.reviewtype === "postreview" && this.selectedoutcomeset.postreviewstatus === COMPLETED) {
        this.selectedoutcomeset.postreviewstatus = FINALISED;
        this.selectedoutcomeset.postreview_shared = true;
        if (this.myreview.currentreview.length > 0 && this.myreview.currentreview[0] != null) {
          this.myreview.currentreview[0].postreviewstatus = FINALISED;
          this.myreview.currentreview[0].postreview_finalised = true;
        }
        this.sharewarning_showcontinue = true;
        this.warning_share_message = "Your answers have been saved. Click on 'Continue' to email your answers now Or click on Cancel to email later.";
      }

      this.savereview();

      this.sharewarning_showcontinue = true;
      //this.resetmodal();
    },
    sharecancelclicked() {
      this.displayclicked(DISPLAY_OUTCOMESET);
      this.share_confirm_css = "";
      this.resetform();
    },
    validateform() {
      this.share_confirm_css = "";
      this.validation_message = [];
      if (this.name.length < 1) {
        this.validation_message.push("Please enter name");
      }
      if (this.dob.length < 1) {
        this.validation_message.push("Please enter date of birth");
      }
      if (this.isympathy && this.studyid.length < 1) {
        this.validation_message.push("Please enter a study id");
      }
      if (this.isympathy && this.hpName.length < 1) {
        this.validation_message.push("Please enter Healthcare professional name");
      }
      if (this.isympathy && this.completedby.length < 1) {
        this.validation_message.push("Please select a value for who completed this form");
      }
      let _hasre = false;
      let _tempentry = this.recipiententry.trim();
      this.recipiententry = _tempentry;
      if (this.validateemail(this.recipiententry)) {
        _hasre = true;
      }
      if (_hasre && this.recipients.length < 1) {
        this.recipients.push(this.recipiententry);
      }
      if (this.recipients.length < 1 && !_hasre) {
        this.validation_message.push(
          "Please enter at least one recipient email"
        );
      }

    },
    sendshareclicked() {
      //console.log("sendshareclicked");
      this.validateform();
      if (this.validation_message.length < 1) {
        this.share_confirm_css = MODAL_ACTIVE_CSS;
      }
    },
    shareconfirmcancelclicked() {
      //console.log("sendshareclicked");

      this.share_confirm_css = "";
    },
    sendshareconfirmedclicked() {
      //console.log("sendshareclicked");
      this.share_confirm_css = "";
      if (this.validation_message.length < 1) {
        this.selectedoutcomeset.lastupdated = helper.getcurrentdate();

        if (this.reviewtype === "prereview") {
          if (this.myreview.currentreview.length > 0 && this.myreview.currentreview[0] != null) {
            this.myreview.currentreview[0].prereviewstatus = FINALISED;
          }
          this.selectedoutcomeset.prereviewstatus = FINALISED;
          this.selectedoutcomeset.prereview_shared = true;
        } else {
          if (this.myreview.currentreview.length > 0 && this.myreview.currentreview[0] != null) {
            this.myreview.currentreview[0].postreviewstatus = FINALISED;
          }
          this.selectedoutcomeset.postreviewstatus = FINALISED;
          this.selectedoutcomeset.postreview_shared = true;
        }
        if (this.selectedoutcomeset.prereviewstatus === FINALISED && this.selectedoutcomeset.postreviewstatus === FINALISED) {
          //move to pastviews

        }
        this.savereview();
        this.sendemailclicked( (result) => {
          //TODO: add callback function here to show email send/not sent message
          console.log("made it to callback for sendemailclicked");
          console.log(result);
          console.log("success");
          this.emailsent_message = "Review sent";
          if (result == "error") {
            this.emailsent_message = "Error, review not sent";
          } else {
            console.log("success");
            this.emailsent_message = "Review sent";
          }
          this.confirm_emailsent_modal_display();
      });
        // this.testsend();
        this.resetmodal();
        this.displayclicked(DISPLAY_MYREVIEWS);

      }
    },
    previewclicked() {
      let info = {
        name: this.name,
        dob: this.dob ? this.getDateOnlyAsString(this.dob) : "",
        studyid: this.studyid,
        date: this.selectedoutcomeset.lastupdated,
        reviewtype:
          this.reviewtype === "prereview" ? "Pre review" : "Post review",
      };
      let pdfhtml = pdfhelper.generateHtmlforPdf(
        this.reviewtype,
        info,
        this.selectedoutcomeset
      );
      this.pdfhtml = pdfhtml;
      this.share_preview_confirm_css = MODAL_ACTIVE_CSS;
    },
    previewcancelclicked() {
      this.share_preview_confirm_css = "";
    },
    deletecurrentreview_clicked() {
      this.warning_deletereview_modal_css = MODAL_ACTIVE_CSS;
      this.deletewarning_showcontinue = true;
      // if(this.myreview.currentreview[0].prereview_finalised || this.myreview.currentreview[0].postreview_finalised)
      // {
      //   this.deletewarning_showcontinue = false;
      // }
      // else{
      //   this.deletewarning_showcontinue = true;
      // }
    },
    deletereviewcancelclicked() {
      this.warning_deletereview_modal_css = "";
    },
    deletereviewconfirmedclicked() {
      this.myreview.currentreview = [];
      this.warning_deletereview_modal_css = "";
      this.savereview();
      this.display_confirm_deleted();
    },
    deletetoppastreview_clicked() {
      this.warning_deletetoppastreview_modal_css = MODAL_ACTIVE_CSS;
    },
    deletetoppastreview_cancelclicked() {
      this.warning_deletetoppastreview_modal_css = "";
    },
    deletetoppastreview_confirmclicked() {
      this.warning_deletetoppastreview_modal_css = "";
      this.myreview.previousreviews.splice(this.myreview.previousreviews.indexOf(this.mostrecent_review), 1);
      this.mostrecent_review = {};
      this.savereview();
      this.display_confirm_deleted();
    },
    deletepastreview_clicked() {
      this.warning_deletepastreview_modal_css = MODAL_ACTIVE_CSS;
    },
    deletepastreview_cancelclicked() {
      this.warning_deletepastreview_modal_css = "";
    },
    deletepastreview_confirmclicked() {
      this.warning_deletepastreview_modal_css = "";
      this.myreview.previousreviews = [];
      this.pastreviews = [];
      this.mostrecent_review = {};
      this.displaysummaryclicked();
      this.displayclicked('summary.previous');
      this.savereview();
      this.display_confirm_deleted();
    },
    deletemostrecentreview_clicked() {
      this.warning_deletemostrecentreview_modal_css = MODAL_ACTIVE_CSS;
    },
    deletemostrecentreview_cancelclicked() {
      this.warning_deletemostrecentreview_modal_css = "";
    },
    deletemostrecentreview_confirmclicked() {
      this.warning_deletemostrecentreview_modal_css = "";
      this.myreview.previousreviews.splice(this.myreview.previousreviews.indexOf(this.mostrecent_review), 1);
      this.pastreviews.splice(this.pastreviews.indexOf(this.mostrecent_review), 1);
      this.mostrecent_review = {};
      this.savereview();
      this.displaysummaryclicked();
      this.display_confirm_deleted();
    },
    display_confirm_deleted() {
      this.confirm_deleted_message_modal_css = MODAL_ACTIVE_CSS;
    },
    confirm_deleted_message_okclicked() {
      this.confirm_deleted_message_modal_css = "";
      this.displayclicked(DISPLAY_MYREVIEWS);
    },
    confirm_emailsent_modal_okclicked() {
      this.resetmodal();
    },
    confirm_emailsent_modal_display() {
      this.confirm_emailsent_modal_css = MODAL_ACTIVE_CSS;
    },
    //confirm_deleted_message_modal_css
    clear() {
      this.myreview.currentreview = [];
      this.myreview.previousreviews = [];
      let data1 = JSON.stringify(this.myreview.currentreview);
      let data2 = btoa(encodeURIComponent(data1));
      let data0 = data2;
      alert("SAVE:POLYREVIEW:" + data0);
      // axios
      //   .post(
      //     "https://127.0.0.1:8989/datastore/save/myreview",
      //     { data: data0 },
      //     {
      //       headers: {
      //         "Content-Type": "application/json",
      //       },
      //     }
      //   )
      //   .then(() => {
      //     //console.log("cleared");
      //   })
      //   .catch((error) => {
      //     console.log("failed" + error);
      //   });
    },
    clearnull() {
      let _prer = [];
      for (let i = 0; i < this.myreview.previousreviews.length; i++) {
        if (this.myreview.previousreviews[i] != null) {
          _prer.push(this.myreview.previousreviews[i]);
        }
      }
      this.myreview.previousreviews = _prer;
    },
    getShareHtml() {
      let _s = [];
      _s.push("<div>");
      _s.push(
        "<table><thead><th>Name</th><th>Date of birth</th><th>Study ID</th><th>Healthcare professional name</th><th>This form was completed by</th><th>Date</th><th>Review type</th></thead><tbody>"
      );
      _s.push(
        "<tr><td>" +
        this.name +
        "</td><td>" +
        this.dob +
        "</td><td>" +
        this.studyid +
        "</td><td>" +
        this.hpName +
        "</td><td>" +
        this.completedby +
        "</td>"
      );

      if (this.reviewtype === "prereview") {
        _s.push("<td>" + this.selectedoutcomeset.lastupdated + "</td>");
      } else {
        _s.push("<td>" + this.selectedoutcomeset.lastupdated + "</td>");
      }
      _s.push("<td>" + this.reviewtype + "</td><tr>");
      _s.push("</tbody></table>");
      _s.push("</div>");

      let res0 = _s.join("");
      let res = encodeURIComponent(res0);
      return res;
    },
    getExcelDataString(d) {

      let _filename = "outcome_" + d;
      let res = "";
      let excel = {
        filename: _filename + ".xlsx",
        sheets: [],
      };
      let _sh1 = {
        sheetname: _filename,
        rows: [],
      };
      let _emptyrow = { cols: [{ value: "" }] };
      let _r1 = {
        cols: [
          { value: "" },
          { value: "Name" },
          { value: "Date of birth" },
          { value: "Study id" },
          { value: "Healthcare professional name" },
          { value: "This form was completed by" },
          { value: "Date" },
          { value: "Outcome set type" },
        ],
      };
      _sh1.rows.push(_r1);
      _sh1.rows.push({
        cols: [
          { value: "" },
          { value: this.name },
          { value: this.getDateOnlyAsString(this.dob) },
          { value: this.studyid },
          { value: this.hpName },
          { value: this.completedby },
          { value: this.selectedoutcomeset.lastupdated },
          { value: this.reviewtype },
        ],
      });
      _sh1.rows.push(_emptyrow);
      let review =
        this.reviewtype === "prereview"
          ? this.selectedoutcomeset.prereview
          : this.selectedoutcomeset.postreview;

      review.forEach((p, idx) => {
        if (idx === 0) {
          _sh1.rows.push({
            cols: [
              { value: "Short Name", color: "FFFF0000" },
              { value: "Section:" },
              { value: p.name },
            ],
          });
        } else {
          _sh1.rows.push({
            cols: [
              { value: "", color: "FFFF0000" },
              { value: "Section:" },
              { value: p.name },
            ],
          });
        }
        if (p.completed) {
          p.questions.forEach((q) => {
            let _ans = this.getAnswer2(q.prevalues);
            //let _shortname = q.shortname?q.shortname:q.name;
            let _shortname = q.shortname;
            if (q.shortname === "") {
              _shortname = q.name;
            }
            _sh1.rows.push({
              cols: [
                { value: _shortname, color: "FFFF0000" },
                { value: q.name },
                { value: _ans },
              ],
            });
          });
        }
        _sh1.rows.push(_emptyrow);
        _sh1.rows.push(_emptyrow);
      });

      let _sh2 = {
        sheetname: "Tabular",
        rows: [],
      };
      let _sh2r0 = {
        cols: [
          { value: "Name" },
          { value: "Date of birth" },
          { value: "Study ID" },
          { value: "Healthcare professional name" },
          { value: "This form was completed by" },
          { value: "Date" },
          { value: "Outcome set type" },
        ],
      };
      review.forEach((p) => {
        if (p.completed) {
          p.questions.forEach((q) => {
            //let _ans = this.getAnswer(q.prevalues);
            let _shortname = q.shortname;
            if (q.shortname === "") {
              _shortname = q.name;
            }
            _sh2r0.cols.push({ value: _shortname });
          });
        }
      });
      _sh2.rows.push(_sh2r0);

      let _sh2r1 = {
        cols: [
          { value: this.name },
          { value: this.getDateOnlyAsString(this.dob) },
          { value: this.studyid },
          { value: this.hpName },
          { value: this.completedby },
          { value: this.selectedoutcomeset.lastupdated },
          { value: this.reviewtype },
        ],
      };
      review.forEach((p) => {
        if (p.completed) {
          p.questions.forEach((q) => {
            let _ans = this.getAnswer2(q.prevalues);
            _sh2r1.cols.push({ value: _ans });
          });
        }
      });

      _sh2.rows.push(_sh2r1);
      excel.sheets.push(_sh1);
      excel.sheets.push(_sh2);
      let res0 = JSON.stringify(excel);
      res = encodeURIComponent(res0);
      return res;
    },
    async sendemailclicked(_callback) {
      let info = {
        name: this.name,
        dob: this.getDateOnlyAsString(this.dob),
        studyid: this.studyid,
        hpName: this.hpName,
        completedby: this.completedby,
        reviewdate: this.getDateOnlyAsString2(
          this.selectedoutcomeset.reviewdate
        ), //this.selectedoutcomeset.reviewdate,
        date: this.selectedoutcomeset.lastupdated,
        reviewtype:
          this.reviewtype === "prereview" ? "Pre review" : "Post review",
      };
      let pdf = pdfhelper.generateHtmlforPdf(
        this.reviewtype,
        info,
        this.selectedoutcomeset
      );
      var base64pdf = pdf.output('datauristring').replace('data:application/pdf;filename=generated.pdf;base64,','');
      let _date = helper.getcurrentdateasnumber();
      let csvtext = this.getExcelDataString(_date);
      let base64excel = btoa(csvtext);

      let studyidhtml = "";
      if (info.studyid.length > 0) {
        studyidhtml = "<strong>Study id : </strong>" + info.studyid + "<br/> <strong>Healthcare professional name : </strong>" + info.hpName + "<br/> <strong>This form was completed by : </strong>" + info.completedby + "<br/>";
      }

      let htmlbody = '<p>This email has been sent by a patient using the Polypharmacy: Manage Medicines app or website provided by the Scottish Government Effective Prescribing and Therapeutics team to support medicines review.  See <a href="http://managemeds.scot.nhs.uk" clicktracking="off" target="_blank" title="Polypharmacy: Manage Medicines">http://managemeds.scot.nhs.uk</a> </p><p>The information in this email is intended to support person-centred consultation and shared decision-making by the patient with the GP or pharmacist conducting their medicines review.</p>' +
        "<p><strong>Sender's name : </strong>" +
        info.name +
        "<br/>" +
        "<strong>Date of birth : </strong>" +
        info.dob +
        "<br/>" +
        studyidhtml +
        "<strong>Review date : </strong>" +
        info.reviewdate +
        "<br/>" +
        "<strong>Review type : </strong>" +
        info.reviewtype +
        "</p>";

      var model = {
        smtp: "smtp.sendgrid.net",
        port: 587,
        sendgrid_username: "apikey",
        sendgrid_password: "###SENDGRID###",
        to: [],
        from: {
          email: 'donotreply@tactuum.com',
          name: "Decision Support",
        },
        replyto: [
          {
            email: 'decisionsupport@dhi-scotland.com',
            name: "Decision Support",
          },
        ],
        subject: "Medicines review responses",
        body: htmlbody,
        attachments: [],
        response_title: "Review sent",
        response_body: "Your review has been sent successfully",
        response_buttontext: "Ok",
      };
      if (this.isympathy && this.studyid.length > 0) {
        model.to.push({ email: 'iSIMPATHY@gov.scot', name: 'iSIMPATHY@gov.scot' });
      }

      model.attachments.push(
        {
          filename: "outcome_" + _date + ".pdf",
          mimetype: "application/pdf",
          base64data: base64pdf,
        }
      );
      if (base64excel.length > 0)//if(info.studyid.length > 0)
      {
        model.attachments.push(
          {
            filename: "outcome_" + _date + ".xlsx",
            mimetype:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            base64data: base64excel,
          }
        );
      }
      this.recipients.forEach((em) => {
        model.to.push({ email: em, name: em });
      });

      let _unencrypted = JSON.stringify(model);
      //let _encrypted = this.encrypt(_unencrypted).toString();
      let _temp = btoa(unescape(encodeURIComponent(_unencrypted)));
      await window.flutter_inappwebview.callHandler('SHARE', _temp).then(function(result) {
        _callback(result);
          // console.log(result);
          // console.log("success");
         
          //   this.emailsent_message = "Review sent";
          //   this.confirm_emailsent_modal_display();
        }).catch((error) => {
          console.log("failed" + error);
          _callback("error");
      });

      // axios
      //   .post(
      //     "https://managemeds.scot.nhs.uk/umbraco/surface/review/sendreview/?key=" + process.env.VUE_APP_KEY, //"https://127.0.0.1:8989/datastore/sharereview",
      //     //"https://tac-dhi-polypharmacy-dev-app.azurewebsites.net/umbraco/surface/review/sendreview/?key="+process.env.VUE_APP_KEY, 
      //     { data: "'" + _temp.toString() + "'" },
      //     {
      //       headers: {
      //         "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      //         //  "Origin": "http://localhost:8989"
      //       },
      //     }
      //   )
      //   .then((r) => {
      //     this.consolelog(r);
      //     if (r.status === 200 && r.data === "success") {
      //       this.consolelog("success");
      //       this.emailsent_message = "Review sent";
      //     }
      //     else {
      //       this.consolelog("failed");
      //       this.emailsent_message = "Review not sent";
      //     }
      //     this.confirm_emailsent_modal_display();
      //   })
      //   .catch((error) => {
      //     this.emailsent_message = "Error, review not sent";
      //     this.confirm_emailsent_modal_display();
      //     this.consolelog("failed" + error);
      //   });
    },
    encrypt(message) {
      let res = "";
      var secret = "###SELECTPDF###";
      var key = CryptoJS.enc.Utf8.parse(secret);
      var iv = CryptoJS.enc.Utf8.parse(secret);
      res = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(message), key,
        {
          keySize: 128 / 8,
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        });

      return res;
    },
    decrypt(encrypted) {
      let res = "";
      let secret = "###SELECTPDF###";
      let key = CryptoJS.enc.Utf8.parse(secret);
      let iv = CryptoJS.enc.Utf8.parse(secret);
      var bytes = CryptoJS.AES.decrypt(encrypted, key,
        {
          keySize: 128 / 8,
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        });
      res = bytes.toString(CryptoJS.enc.Utf8);
      return res;
    },
    testsend() {
      console.log(process.env.VUE_APP_APP_DOMAIN);
      let info = {
        name: this.name,
        dob: this.getDateOnlyAsString(this.dob),
        studyid: this.studyid,
        hpName: this.hpName,
        completedby: this.completedby,
        reviewdate: this.getDateOnlyAsString2(
          this.selectedoutcomeset.reviewdate
        ), //this.selectedoutcomeset.reviewdate,
        date: this.selectedoutcomeset.lastupdated,
        reviewtype:
          this.reviewtype === "prereview" ? "Pre review" : "Post review",
      };
      let pdfhtml = pdfhelper.generateHtmlforPdf(
        this.reviewtype,
        info,
        this.selectedoutcomeset
      );
      let base64pdf = btoa(pdfhtml);
      let _date = helper.getcurrentdateasnumber();
      let csvtext = this.getExcelDataString(_date);
      let base64excel = btoa(csvtext);

      let studyidhtml = "";
      if (info.studyid.length > 0) {
        studyidhtml = "<strong>Study id : </strong>" + info.studyid + "<br/> <strong>Healthcare professional name : </strong>" + info.hpName + "<br/> <strong>This form was completed by : </strong>" + info.completedby + "<br/>";
      }

      let htmlbody = '<p>This email has been sent by a patient using the Polypharmacy: Manage Medicines app or website provided by the Scottish Government Effective Prescribing and Therapeutics team to support medicines review.  See <a href="http://managemeds.scot.nhs.uk" clicktracking="off" target="_blank" title="Polypharmacy: Manage Medicines">http://managemeds.scot.nhs.uk</a> </p><p>The information in this email is intended to support person-centred consultation and shared decision-making by the patient with the GP or pharmacist conducting their medicines review.</p>' +
        "<p><strong>Sender's name : </strong>" +
        info.name +
        "<br/>" +
        "<strong>Date of birth : </strong>" +
        info.dob +
        "<br/>" +
        studyidhtml +
        "<strong>Review date : </strong>" +
        info.reviewdate +
        "<br/>" +
        "<strong>Review type : </strong>" +
        info.reviewtype +
        "</p>";

      var model = {
        smtp: "smtp.sendgrid.net",
        port: 587,
        sendgrid_username: "apikey",
        sendgrid_password: "###SENDGRID###",
        to: [],
        from: {
          email: 'noreply@em2986.tactuum.com',
          name: "Decision Support",
        },
        replyto: [
          {
            email: 'decisionsupport@dhi-scotland.com',
            name: "Decision Support",
          },
        ],
        subject: "Medicines review responses",
        body: btoa(htmlbody),
        attachments: [],
        response_title: "Review sent",
        response_body: "Your review has been sent successfully",
        response_buttontext: "Ok",
      };
      model.to.push({ email: 'mmurray@tactuum.com', name: 'mmurray@tactuum.com' });
      model.attachments.push(
        {
          filename: "outcome_" + _date + ".pdf",
          mimetype: "application/pdf",
          base64data: base64pdf,
        }
      );
      if (base64excel.length > 0)//if(info.studyid.length > 0)
      {
        model.attachments.push(
          {
            filename: "outcome_" + _date + ".xlsx",
            mimetype:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            base64data: base64excel,
          }
        );
      }
      this.recipients.forEach((em) => {
        model.to.push({ email: em.email, name: em.name });
      });

      let _unencrypted = JSON.stringify(model);
      let _encrypted = this.encrypt(_unencrypted).toString();
      let _temp = btoa(_encrypted.toString());
      axios
        .post(
          "https://managemeds.scot.nhs.uk/umbraco/surface/review/sendreview/?key=" + process.env.VUE_APP_KEY, //"https://127.0.0.1:8989/datastore/sharereview",
          { data: "'" + _temp.toString() + "'" },
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8;"
            },
          }
        )
        .then((r) => {
          this.consolelog(r);
          if (r.status === 200 && r.data === "success") {
            this.consolelog("success");
            this.emailsent_message = "Review sent";
          }
          else {
            this.consolelog("failed");
            this.emailsent_message = "Review not sent";
          }
          this.confirm_emailsent_modal_display();
        })
        .catch((error) => {
          this.emailsent_message = "Review not sent";
          this.confirm_emailsent_modal_display();
          this.consolelog("failed" + error);
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../../scss/layouts/header.scss";
@import "../../../scss/elements/_buttons.scss";
@import "../../../scss/elements/_panels.scss";
@import "../../../scss/elements/_listing.scss";
@import "../../../scss/controls/_tabs.scss";
@import "../../../scss/forms/_form.scss";
@import "../../../scss/controls/_inputFields.scss";
</style>

